export interface BulkInteractionRow {
  readonly label: string;
  readonly body: string;
  readonly date: string;
}

/** Parses clipboard tables (TSV) and RFC-4180-style CSV without evaluating markup. */
export function parseInteractionRows(source: string): readonly BulkInteractionRow[] {
  const delimiter = firstRecord(source).includes('\t') ? '\t' : ',';
  const records = parseDelimited(source, delimiter).filter((row) => row.some((cell) => cell.trim()));
  const first = records[0]?.map((cell) => cell.trim().toLowerCase()) ?? [];
  const hasHeader = first[0] === 'label' && (first[1] === 'body' || first[1] === 'content');
  return records.slice(hasHeader ? 1 : 0).map((row) => ({
    label: row[0]?.trim() ?? '',
    body: row[1]?.trim() ?? '',
    date: row[2]?.trim() ?? '',
  }));
}

function firstRecord(source: string): string {
  let quoted = false;
  for (let index = 0; index < source.length; index += 1) {
    const character = source[index];
    if (character === '"') quoted = !quoted;
    if (!quoted && (character === '\n' || character === '\r')) return source.slice(0, index);
  }
  return source;
}

function parseDelimited(source: string, delimiter: string): string[][] {
  const rows: string[][] = [];
  let row: string[] = [];
  let field = '';
  let quoted = false;

  for (let index = 0; index < source.length; index += 1) {
    const character = source[index] ?? '';
    if (quoted) {
      if (character === '"' && source[index + 1] === '"') {
        field += '"';
        index += 1;
      } else if (character === '"') {
        quoted = false;
      } else {
        field += character;
      }
      continue;
    }
    if (character === '"' && field.length === 0) quoted = true;
    else if (character === delimiter) {
      row.push(field);
      field = '';
    } else if (character === '\n' || character === '\r') {
      if (character === '\r' && source[index + 1] === '\n') index += 1;
      row.push(field);
      rows.push(row);
      row = [];
      field = '';
    } else {
      field += character;
    }
  }
  if (field.length > 0 || row.length > 0) {
    row.push(field);
    rows.push(row);
  }
  return rows;
}
